<template>
  <div class="modal is-active">
    <div class="modal-background" @click="cancel"></div>
    <div class="modal-card">
      <!-- Modal Header -->
      <header class="modal-card-head" :class="{ mobile: isMobile }">
        <p v-if="localItem.id" class="modal-card-title">
          {{ preferCategoryLabel(localItem.fireProtection)}}
        </p>
        <p v-else class="modal-card-title">{{ $t('itemmodal.new_inventory') }}</p>

        <!-- Fire Extinguisher Dropdowns -->
        <div v-if="$isAllowedTo('floor_areas_edit')" class="header-select">
          <p>{{ $t('itemmodal.inventory_group') }}</p>
          <v-select
            class="panel-select"
            v-model="chosenInventoryGroup"
            :options="fireProtectionGroupMap"
            :placeholder="$t('itemmodal.select_fire_protection')"
            :allowEmpty="false"
            :internalSearch="true"
            :showLabels="false"
            @input="filterFireProtections()"
            track-by="index"
            label="text"
          />
        </div>

        <div v-if="$isAllowedTo('floor_areas_edit')" class="header-select">
          <p>{{ $t('itemmodal.inventory_type_short') }}</p>
          <TypeDropdown v-model="chosenInventoryType" :items="filterdfireProtections" />
        </div>

        <div v-else class="addmapitem_subtitle">
               <p>{{ $t('itemmodal.inventory_type') }}: {{ tTypeKey(localItem.fireProtection.inventoryType) }}</p>
        </div>

        <button class="delete" aria-label="close" @click="cancel"></button>
      </header>

      <!-- Modal Body -->
      <section class="modal-card-body not-mobile">
       
        <!-- Technical Information Accordion -->
        <section class="accordion">
          <input type="checkbox" name="collapse" id="handle1" checked />
          <h2 class="handle">
            <label for="handle1">{{ $t('itemmodal.pos_information') }}</label>
          </h2>
          <div class="content">
                    <div class="fields-grid">
         <div class="field">
                <div class="label white">{{ $t('itemmodal.year') }}</div>
                <div class="control">
                  <input
                    class="input"
                    type="number"
                    v-model="localYear"
                    :disabled="!$isAllowedTo('floor_areas_edit')"
                  />
                </div>
              </div>
              <div class="field">
                <div class="label white">{{ $t('itemmodal.pos_no') }}</div>
                <div class="control">
                  <input
                    class="input"
                    type="number"
                    v-model.number="localItem.positionNumber"
                    :disabled="!$isAllowedTo('floor_areas_edit')"
                  />
                </div>
              </div>
         <div class="field textarea-full">
                <div class="label white">{{ $t('itemmodal.placement') }}</div>
                <div class="control">
                  <textarea
                    class="textarea no-resize"
                    rows="2"
                    v-model="localItem.placementDescription"
                    :disabled="!$isAllowedTo('floor_areas_edit')"
                  ></textarea>
                </div>
              </div>
              </div>
          </div>
        </section>
        <!-- Technical Information Accordion -->
        <section class="accordion">
          <input type="checkbox" name="collapse" id="handle2"  checked />
          <h2 class="handle">
            <label for="handle2">{{ $t('itemmodal.technical_information') }}</label>
          </h2>
          <div class="content">
            <div class="fields-grid" >
          
           
              <div class="field">
                <div class="label white">{{ $t('itemmodal.size') }}</div>
                <div class="control">
                  <input
                    class="input"
                    type="text"
                    v-model="localItem.size"
                    :disabled="!$isAllowedTo('floor_areas_edit')"
                  />
                </div>
              </div>
              <div class="field">
                <div class="label white">{{ $t('itemmodal.manufacturer') }}</div>
                <div class="control">
                  <input
                    class="input"
                    type="text"
                    v-model="localItem.manufacture"
                    :disabled="!$isAllowedTo('floor_areas_edit')"
                  />
                </div>
              </div>
              <div class="field textarea-full">
                <div class="label white">{{ $t('itemmodal.other') }}</div>
                <div class="control">
                  <input
                    class="input"
                    type="text"
                    v-model="localItem.other"
                    :disabled="!$isAllowedTo('floor_areas_edit')"
                  />
                </div>
              </div>
              <!-- Textarea for Placement -->
           
            </div>
          </div>
        </section>

        <!-- Service Information Accordion -->
    <section
      class="accordion"
      v-if="visibleFields && visibleFields.length > 0"
      :key="(chosenInventoryType && chosenInventoryType.inventoryType) || ''"
    >
  <input type="checkbox" name="collapse3" id="handle3" checked  />
  <h2 class="handle">
    <label for="handle3">{{ $t('itemmodal.service_information') }}</label>
  </h2>
  <div class="content">
    <div class="fields-grid">
      <div
        class="field"
        v-for="field in visibleFields"
        :key="field"
        :class="{ 'textarea-full': !isInputField(field) }"
      >
        <div v-if="fieldLabels[field]" class="label white">
         {{ $t(fieldLabels[field]) }}
        </div>
        <div class="control">
          <textarea
            v-if="!isInputField(field)"
            class="textarea no-resize"
            rows="2"
            v-model="localItem.mapItemExtra[field]"
            :disabled="!$isAllowedTo('floor_areas_edit')"
          ></textarea>
          <input
          v-else
          class="input"
          :type="numberFieldsLc.has(field.toLowerCase()) ? 'number' : 'text'"
          :value="localItem.mapItemExtra[field]"
          @input="onExtraInput(field, $event.target.value)"
          :disabled="!$isAllowedTo('floor_areas_edit')"
        />
        </div>
      </div>
    </div>
  </div>
</section>

      </section>

      <!-- Modal Footer -->
      <footer class="modal-card-foot">
        <button
          class="button is-dark"
          :class="isLoading ? 'is-loading' : ''"
          @click="save"
          v-if="$isAllowedTo('floor_areas_edit')"
        >
          <span class="icon is-info"><i class="fas fa-save" /></span>
          <span>{{ $t('itemmodal.save') }}</span>
        </button>
        <button
          class="button is-dark"
          @click="deleteItem"
          v-if="$isAllowedTo('floor_areas_edit') && localItem.fireProtection.id"
        >
          <span class="icon"><i class="fas fa-trash" /></span>
          <span>{{ $t('itemmodal.delete') }}</span>
        </button>
        <button
          class="button is-dark"
          @click="cancel"
          v-if="$isAllowedTo('floor_areas_edit')"
        >
          <span class="icon"><i class="fas fa-ban" /></span>
          <span>{{ $t('itemmodal.cancel') }}</span>
        </button>
      </footer>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import iconMixin from "@/mixins/iconMixin.js";
import fireEquipmentService from "@/mixins/fireEquipmentService.js";
import TypeDropdown from '@/components/TypeDropdown.vue';
export default {
  mixins: [iconMixin],
  components: { TypeDropdown },
  props: {
    item: Object,
    fireProtections: Array,
    hasMapFile: Boolean,
  },
  data() {

    return {
      fireProtectionOptions: [],
      filterdfireProtections: [],
      chosenInventoryType: null,
      chosenInventoryGroup: [],
      fireProtectionGroupMap: [],
      localItem: { mapItemExtra: {},  fireProtection: {},  },
      isLoading: false,
      localYear: "",
      fieldLabels: fireEquipmentService.getFieldLabels(),
      fieldMap: fireEquipmentService.getFieldMap(),
      numberFieldsLc: new Set([
        "chargeYear","revisionYear","installationYear","testPressureYear",
        "BatteryInstallationYear","BatteryRevisionYear",
        "ElectrodesInstallationYear","ElectrodesRevisionYear",
        "fusibleLinkDegrees","gasspringRevisionYear",
        'batteryRevisionYear','batteryInstallationYear','electrodesRevisionYear',
        'electrodesInstallationYear','fusibleLinkYear','gasspringRevisionYear',
        'RevisionYear','ChargeYear','InstallationYear','TestPressureYear',
        'FusibleLinkYear','FusibleLinkDegrees','GasspringRevisionYear'
      ].map(s => s.toLowerCase())),
    };
  },
  computed: {
    ...mapState("fireProtectionStore", ["fireExtinguishers"]),
    ...mapGetters("appStore", ["isMobile"]),
    year() {
      if (this.localYear) {
        return this.localYear;
      }

      return "";
    },
    visibleFields() {
      const type =
        this.chosenInventoryType?.inventoryType ||
        this.localItem.fireProtection?.inventoryType;
      return fireEquipmentService.getVisibleFields(type) || [];
    },
  },
  watch: {
    chosenInventoryType: function (to) {
      this.localItem.fireProtection = to;
    },
    year: function (val) {
      if (val.length >= 4) {
        this.localYear = val.substr(0, 4);
      }
    },
  },
  methods: {
   syncServiceFields() {
    const type = this.localItem.fireProtection?.inventoryType;
    const fields = fireEquipmentService.getVisibleFields(type) || [];
    // start from a normalized copy so read/write stays consistent
    this.normalizeExtraKeys();
    const next = { ...this.localItem.mapItemExtra };
    fields.forEach((f) => {
      const val = this.getExtra(f);
      const isEmpty = val === undefined || val === null || val === '';
      const isNum = this.numberFieldsLc.has(String(f).toLowerCase());
      if (isEmpty) next[f] = isNum ? null : '';
    });
    this.$set(this.localItem, 'mapItemExtra', next);
  },
   getExtra(field) {
    const extra = this.localItem?.mapItemExtra || {};
    if (extra[field] !== undefined) return extra[field];
    const lc = String(field).toLowerCase();
    for (const k in extra) {
      if (String(k).toLowerCase() === lc) return extra[k];
    }
    return this.numberFieldsLc.has(lc) ? null : '';
  },
  setExtra(field, val) {
    const extra = this.localItem.mapItemExtra || {};
    const lc = String(field).toLowerCase();
    for (const k in extra) {
      if (k !== field && String(k).toLowerCase() === lc) {
        this.$delete(extra, k);
      }
    }
    this.$set(extra, field, val);
  },
  onExtraInput(field, raw) {
    const isNum = this.numberFieldsLc.has(String(field).toLowerCase());
    const coerced = isNum
      ? (raw === '' || raw === null ? null : Number(raw))
      : raw;
    this.setExtra(field, coerced);
  },
  normalizeExtraKeys() {
    const extra = this.localItem?.mapItemExtra || {};
    const normalized = {};
    const fields = this.visibleFields || [];
    fields.forEach(f => {
      const v = this.getExtra(f);
      if (v !== undefined) normalized[f] = v;
    });
    for (const k in extra) {
      const already = Object.keys(normalized).some(f => f.toLowerCase() === k.toLowerCase());
      if (!already) normalized[k] = extra[k];
    }
    this.$set(this.localItem, 'mapItemExtra', normalized);
  },
  isInputField(field) {
    const textFields = ["Comment"]; // dessa är textarea
    return !textFields.includes(field);
  },
     tTypeFromOption(option) {
    const type = option?.inventoryType || option?.fireProtection?.inventoryType || option;
    return this.tTypeKey(type);
  },
    getFireProtectionOptions() {
      if (this.hasMapFile && !this.isMobile) {
        let extinguisherOptions = JSON.parse(JSON.stringify(this.fireProtections)).reduce(
          (acc, fireprot) => {
            if (
              this.fireExtinguishers.some(
                (extinguisher) => extinguisher === fireprot.inventoryType
              )
            )
              acc.push(fireprot);

            return acc;
          },
          []
        );

        return extinguisherOptions;
      } else {
        return this.fireProtections;
      }
    },
    optionLabel(opt) {
      return this.displayFPTitle(opt);
    },
      filterFireProtections() {
    if (this.chosenInventoryGroup.index > -1) {
      this.filterdfireProtections = this.fireProtectionOptions.filter(
        x => x.fireProtectionType === this.chosenInventoryGroup.index
      );
    } else {
      this.filterdfireProtections = this.fireProtectionOptions;
    }

    this.chosenInventoryType = this.filterdfireProtections[0] || null;

    this.$nextTick(() => {
      this.localItem.fireProtection = this.chosenInventoryType || {};
      this.syncServiceFields();
    });
  },
    

   save() {
    if (!this.localItem.mapItemExtra) this.localItem.mapItemExtra = {};
    this.normalizeExtraKeys(); // ensure canonical keys before packaging

    const fields = fireEquipmentService.getVisibleFields(
      this.localItem.fireProtection?.inventoryType
    ) || [];

    const prev = this.localItem.mapItemExtra;

    const meta = ['id', 'created', 'updated', 'deleted'];
    const metaObj = {};
    meta.forEach(k => { if (prev[k] !== undefined) metaObj[k] = prev[k]; });

    const nextExtra = { ...metaObj };
    fields.forEach(f => {
      const isNum = this.numberFieldsLc.has(String(f).toLowerCase());
      let val = this.getExtra(f);
      if (val === undefined || val === '') val = isNum ? null : '';
      if (isNum && val !== null) val = Number(val);
      nextExtra[f] = val;
    });

    this.localItem.mapItemExtra = nextExtra;

    const year = String(this.localYear || '').trim();
    this.localItem.year = year && year.length >= 4
      ? `${year.substring(0,4)}-01-01T00:00:00`
      : null;

    const payload = {
      ...this.localItem,
      fireProtectionId: this.localItem.fireProtection?.id,
      mapItemExtra: nextExtra
    };

    this.$emit("save", payload);
    this.isLoading = true;
  },
    cancel() {
      this.$emit("cancel");
    },
    deleteItem() {
      this.$emit("delete", this.localItem);
    },
  },
  created() {
 
    this.localItem = Object.assign({}, this.item);
  if (!this.localItem.mapItemExtra) {
    this.localItem.mapItemExtra = {};
  }

   if (this.item.fireProtection) {
      this.chosenInventoryType = this.item.fireProtection;
      this.localYear = (this.localItem.year ? String(this.localItem.year).substring(0, 4) : '');
    } else {
      this.chosenInventoryType = Object.assign({}, this.fireProtections[0]);
      this.localItem.fireProtection = Object.assign({}, this.fireProtections[0]);
    }
    this.fireProtectionGroupMap = Object.values(this.getFireProtectionGroupMap()).map(
      (item, index) => {
        return { index, text: item };
      }
    );

    this.filterdfireProtections,
    (this.fireProtectionOptions = this.getFireProtectionOptions());
    this.fireProtectionGroupMap.unshift({ index: -1, text: this.$t('itemmodal.all_selected') });
    this.chosenInventoryGroup = this.fireProtectionGroupMap[0];
    this.syncServiceFields();
  },

};
</script>
<style lang="scss" scoped>
.modal-card-head {
  display: block;
  flex-wrap: wrap;
  .delete {
    position: absolute;
    top: 0.65rem;
    right: 0.6rem;
  }
  &.mobile {
    .modal-card-title {
      min-width: 150px;
    }
  }
}
</style>
<style lang="scss">
.addmapitem_subtitle {
  font-size: 1.25rem;
  color: #f3f3f3;
  float: right;
}
.addmapitem_subtitle {
  margin-right: 20px;
}
.header-select {
  position: relative;
  // margin-left: auto;
  margin-top: 0.5rem;
  flex-direction: column;

  margin-bottom: -5px;
  // width: 200px;
  display: flex;
  p {
    white-space: nowrap;
    margin-top: 0.5rem;
    margin-right: 0.5rem;
  }
}
/*
 CSS for the main interaction
*/
.accordion > input[type="checkbox"] {
  position: absolute;
  left: -100vw;
}

.accordion .content {
  overflow-y: hidden;
  height: 0;
  transition: height 0.3s ease;
}

.accordion > input[type="checkbox"]:checked ~ .content {
  height: auto;
  overflow: visible;
}

.accordion label {
  display: block;
}

.accordion {
  margin-bottom: 1em;
}



.accordion .handle {
box-shadow: 0 0 0 0.25px #ffffff;
border-radius: 2px;
  margin: 0;
  font-size: 1em;
  line-height: 1em;
  margin-top: 10px;
}

.accordion label {
  color: #ffffff;
  cursor: pointer;
  font-weight: normal;
  padding: 10px;
}

.accordion .handle :hover,
.accordion .handle :focus {
  // background: #858585;
}

.accordion .handle label:before {
  content: "+"; /* plus */
  display: inline-block;
  margin-right: 10px;
  font-size: 1em;
  line-height: 1.5em;
  vertical-align: middle;
}

.accordion > input[type="checkbox"]:checked ~ .handle label:before {
  content: "−"; /* minus */
}


*,
*:before,
*:after {
  box-sizing: border-box;
}

.accordion {
  max-width: 65em;
}

.accordion p:last-child {
  margin-bottom: 0;
}
.fields-grid {
  margin-top: 10px;
  
  display: grid;
  grid-template-columns: repeat(2, 1fr); /* 2 kolumner */
  gap: 0.5rem; /* mellanrum mellan fälten */
}

.field.textarea-full {
  grid-column: 1 / -1; /* textarea tar hela raden */
}

.input, .textarea {
  width: 100%;
}
.field{
  margin-bottom: 5px !important;
}
.label{
  margin-bottom: 2px !important;
}
</style>
